// SecondPage.js (Updated Component)
import React from 'react'
import styled from 'styled-components'

function SecondPage({ title, para }) {
  return (
    <Container>
      <Wrap>
        <Head>
          <h1 className='shine'>{title}</h1>
          <p>{para}</p>
        </Head>
      </Wrap>
    </Container>
  )
}

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

const Wrap = styled.div`
  width: 90%;
  padding: 40px 0;

  @media only screen and (max-width: 1200px) {
    width: 98%;
  }
`

const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  h1 {
    text-align: center;

    @media only screen and (max-width: 1200px) {
      font-size: 35px;
    }
  }

  p {
    text-align: center;
    color: #fff;
    margin: 20px 0;
    line-height: 2.1rem;

    @media only screen and (max-width: 1200px) {
      font-size: 14px;
      padding: 5px 0;
    }
  }
`

export default SecondPage
